<template>
  <div class="bjy-playback-notice"></div>
</template>

<script>
export default {
  components: {},
  data () {
    return {

    }
  },
  computed: {},
  watch: {},
  methods: {},
  created () {},
  mounted () {
    BJY.Notice.create({
      element: $('.bjy-playback-notice'),
      foldDefault: true, // 公告是否默认折叠(默认折叠后新公告不会主动展开)
      defaultContent: '公告栏空空的...' // 没有公告时默认显示内容
    })
  },
  beforeDestroy () {}
}
</script>

<style lang='scss'>
//@import url(); 引入公共css类
.bjy-notice {
  position: absolute;
  top: -34px;
  width: 100%;
  left: 0;
  padding: 0;
  background: #fff;
  border-top: 1px solid #ccc;
  box-sizing: border-box;
  z-index: 99;
  .bjy-super-notice {
    padding: 0 6px;
    background: #fff;
  }

  .bjy-content {
    line-height: 30px;
  }
}
</style>
